<div class="content" [class.beheer]="urlService.isBeheer()">
	<router-outlet></router-outlet>
</div>
@if (navigatieVoorkeurService.nieuweNavigatie()) {
	<app-hoofdnavigatie></app-hoofdnavigatie>
	<app-paginakop></app-paginakop>
} @else {
	<div class="corner" [class.show]="userMenuService.showTopLevelMenu()">
		<a routerLink="/"><img src="/assets/img/CumLaude_Logo_white.svg" /></a>
	</div>
	<app-hamburger-menu [class.show]="userMenuService.showHamburgerMenu()"></app-hamburger-menu>
	<app-header></app-header>
}
